export default class AccountModel {
  email = ''
  fullname = ''
  id = ''
  is_admin = ''
  name = ''
}
